import {Menu} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {PipelineEntity} from "@ots-frontend/ots-data";
import {useCallback, useMemo} from "react";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";
import {IconChartDots3, IconEdit, IconTrash} from "@tabler/icons-react";

export type PipelineAction = "EDIT" | "NEW_PIPELINE_GRAPH" | "DELETE"

export type PipelineActionMenuDropdownProps = {
  pipeline: PipelineEntity
  onActionClick?: (action: PipelineAction) => void
}

export const PipelineActionMenuDropdown = (props: PipelineActionMenuDropdownProps) => {
  const {pipeline, onActionClick} = props

  const {hasAccess} = useAuth()
  const {t} = useTranslation(["common"])

  const actions: Set<PipelineAction> = useMemo(() => {
    const actions = new Set<PipelineAction>()
    if (hasAccess("pipeline_edit")) {
      actions.add("EDIT")
    }
    if (hasAccess("pipeline_edit", "pipelinegraph_create")) {
      actions.add("NEW_PIPELINE_GRAPH")
    }
    if (hasAccess("pipeline_delete")) {
      actions.add("DELETE")
    }
    return actions
  }, [pipeline, hasAccess])

  const _onActionClick = useCallback((action: PipelineAction) => {
    if (onActionClick) {
      onActionClick(action)
    }
  }, [onActionClick])

  return (
    <>
      {actions.size === 0 &&
        <Menu.Item>
          {t("common.action.none", "No Actions")}
        </Menu.Item>
      }
      {actions.has("EDIT") &&
        <Menu.Item
          onClick={() => _onActionClick("EDIT")}
          icon={<IconEdit size={14}/>}>
          {t("common.action.edit", "Edit")}
        </Menu.Item>
      }
      {actions.has("NEW_PIPELINE_GRAPH") &&
        <Menu.Item
          onClick={() => _onActionClick("NEW_PIPELINE_GRAPH")}
          icon={<IconChartDots3 size={14}/>}>
          {t("common.action.new", "New") + " " + t("common.entity.pipelinegraph", "Pipeline Graph")}
        </Menu.Item>
      }
      {actions.has("DELETE") &&
        <>
          {actions.size > 1 && <Menu.Divider/>}
          <Menu.Item
            onClick={() => _onActionClick("DELETE")}
            icon={<IconTrash size={14}/>}
            color="red">
            {t("common.action.delete", "Delete")}
          </Menu.Item>
        </>
      }
    </>
  )
}
